
<SupplierDetailTable
    :table-settings="tableSettings"
    :debounce="debounce"
    :sort-options="sortOptions"
    ref="data_table"
    @row-clicked="
        (item) => {
                $router.push({
                    name: 'tender-detail',
                    params: {
                        version: analysisVersion,
                        hash: analysisHash,
                        slug: item.slug
                    }
                });
            }
        "
>
    <template v-slot:cell(risk)="row">
        <RiskLevelDumpling :value="row.item.risk" :level="versionRiskLevel(row.item, analysisVersion)" />
    </template>

    <template v-slot:cell(flags)="row">
        <FlagDetailRowToggler :row="row" :callback="loadRowDetail" />
    </template>

    <template v-slot:cell(price)="row">
        {{ formatNumber(row.value) }}
    </template>

    <template v-slot:cell(title)="row">
        {{ row.item.title }}
        <div v-if="row.item.award_url_profile || row.item.award_url_vestnik ">
            <a v-if="row.item.award_url_vestnik " :href="row.item.award_url_vestnik" target="_blank">{{ $t("vestnik_url") }}<b-icon icon="box-arrow-up-right" font-scale="0.6" style="margin-bottom: 5px;"/></a>
            <span v-if="row.item.award_url_profile && row.item.award_url_vestnik">, </span>
            <a v-if="row.item.award_url_profile" :href="row.item.award_url_profile" target="_blank">{{ $t("profile_url") }}<b-icon icon="box-arrow-up-right" font-scale="0.6" style="margin-bottom: 5px;"/></a>
        </div>
    </template>

    <template v-slot:cell(signature_date)="row">
        <template v-if="row.item.estimated_signature_date">{{ row.value | moment("YYYY") }}</template>
        <template v-else>{{ row.value | moment("D. M. YYYY") }}</template>
    </template>

    <template v-slot:row-details="row">
        <FlagDetailRow :row="row" :version="analysisVersion" />
    </template>
</SupplierDetailTable>
